
import $ from "jquery"

const onLoad = () => {
  const $browserNotice = $("#cell--browser--upgrade--notice")
  if ($browserNotice.length ===  0) { return }

  setTimeout(() => {
    $browserNotice.hide()
  }, 20 * 1000) // 20 sec
}

export default {
  onLoad,
}
